import {createAction} from "@reduxjs/toolkit";
import {ProductionVolumeSearchCriteria} from "@ots-frontend/ots-data";

export const setUIProductionVolumeSearchFilter = createAction<ProductionVolumeSearchCriteria>("ots-ui/production-volume/setSearchFilter");
